import { Avatar, AvatarGroup, Button, Paper, Stack, Typography } from '@mui/material';

import TrustPilotLogo from 'assets/img/Trustpilot/TP-Logo-Tricolor.svg';
import BethanyAvatar from 'assets/img/avatars/bethany_clark_avatar.webp';
import TashaAvatar from 'assets/img/avatars/tasha_jones_avatar.webp';
import WillianAvatar from 'assets/img/avatars/willian_iralzabal_avatar.webp';
import CloseIcon from 'modules/common/components/Icons/CloseIcon';

const TRUSTPILOT_AVATARS = [BethanyAvatar, WillianAvatar, TashaAvatar];

interface TrustPilotPromptProps {
    title?: string;
    description?: string;
    buttonLabel?: string;
    onContinue: () => void;
    onClose?: () => void;
}

export default function TrustPilotPrompt({
    title = 'Thank you for your feedback!',
    description = 'Share it on Trustpilot to help other solopreneurs. Takes less than a minute.',
    buttonLabel = 'Post my Review',
    onContinue,
    onClose,
}: TrustPilotPromptProps) {
    return (
        <Stack width={1} spacing={1.5}>
            {onClose && (
                <Stack direction="row" justifyContent="flex-end">
                    <CloseIcon size="small" onClick={onClose} />
                </Stack>
            )}
            <Typography variant="h3">{title}</Typography>
            <Typography variant="body1" color="text.secondary">
                {description}
            </Typography>
            <Paper variant="filled">
                <Stack direction="row" minHeight={120}>
                    <Stack flex={1} direction="row" alignItems="center">
                        <AvatarGroup
                            sx={{
                                pl: 3,
                                '& .MuiAvatar-root': {
                                    marginLeft: -1,
                                    width: 40,
                                    height: 40,
                                },
                            }}>
                            {TRUSTPILOT_AVATARS.map((image) => (
                                <Avatar key={image} src={image} variant="medium" />
                            ))}
                        </AvatarGroup>
                    </Stack>
                    <Stack flex={1} direction="row" justifyContent="flex-end" alignItems="center" pr={3}>
                        <Stack>
                            <img src={TrustPilotLogo} alt="Trustpilot logo" height={38} />
                        </Stack>
                    </Stack>
                </Stack>
            </Paper>
            <Button variant="contained" fullWidth onClick={onContinue}>
                {buttonLabel}
            </Button>
        </Stack>
    );
}
